'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _RegularRule = require('../plugins/RegularRule');

var _RegularRule2 = _interopRequireDefault(_RegularRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule(name) {
  var decl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments[2];
  var jss = options.jss;

  if (jss) {
    var rule = jss.plugins.onCreateRule(name, decl, options);
    if (rule) return rule;
  }

  // It is an at-rule and it has no instance.
  if (name && name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _RegularRule2['default'](name, decl, options);
}


//////////////////
// WEBPACK FOOTER
// ./~/jss/lib/utils/createRule.js
// module id = 58
// module chunks = 0